import { useQuery } from '@tanstack/react-query';
import type { Permission } from '@agentisai/shared-types';
import { useAuth } from '../auth/AuthProvider';
import { getMe } from './client';
import { keys } from './keys';

/**
 * The caller's platform permissions (ADR-0072). UX only — it decides whether
 * a staff surface is SHOWN; every staff route re-checks the grant server-side.
 * Long-lived: grants change by an operator script, not mid-session.
 */
export function useMe() {
  const { getAccessToken } = useAuth();
  return useQuery({
    queryKey: keys.me(),
    queryFn: ({ signal }) => getMe({ getAccessToken, signal }),
    staleTime: 10 * 60_000,
  });
}

/** True only once `/me` has answered with the permission — never while loading or on error. */
export function useCan(permission: Permission): boolean {
  return useMe().data?.data.permissions.includes(permission) ?? false;
}
